import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface BarrierElement {
  barrier: string;
  mgtElement: number;
  mgtScore: number;
  mgtControlPrimary: string;
  sceId: string;
  sceDescription: string;
  processScore: number;
  type: string;
  sce: string;
  owner: string;
  eff: number;
  id: number;
  asset: string;
}

interface HazardProject {
  hazard: BarrierElement[];
  project_id: number;
  project: string
}

interface HazardState {
  hazard: HazardProject[]
}

const initialState: HazardState = {
  hazard: [],
};

const hazardSlice = createSlice({
  name: 'hazard',
  initialState,
  reducers: {
    setHazardValue: (state, action: PayloadAction<Partial<HazardProject>>) => {
      const { project_id } = action.payload;
      const index = state.hazard.findIndex(item => item.project_id === project_id);

      if (index !== -1) {
        state.hazard[index] = { ...state.hazard[index], ...action.payload };
      } else {
        state.hazard.push(action.payload as HazardProject);
      }
    },
  },
});

export const { setHazardValue } = hazardSlice.actions;
export default hazardSlice.reducer;
